<div class="flag-filter-icon" (click)="onFilterButtonClicked()">
  <i class="fa-solid fa-flag" [ngClass]="'tag_' + flag"></i>
</div>
